import enumeration from "./enumeration";

const BookingItemPropertyType = {
  ASSIGNED_SPACE: "ASSIGNED_SPACE",
};

export default enumeration(BookingItemPropertyType);
